import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var tableEditingKey = new PluginKey('selectingCells');
export var fixTablesKey = new PluginKey('fix-tables');